import './Profile.css';
import React, { useState } from 'react';
import usePopup from '../../utils/hooks/usePopup';
import { Avatar } from '../../components/Avatar/Avatar';
import { IcoLike } from '../../components/svg/IcoLike';
import { IcoFacebook } from '../../components/svg/IcoFacebook';
import { IcoVk } from '../../components/svg/IcoVk';
import { IcoBattle } from '../../components/svg/IcoBattle';
import { IcoCrown } from '../../components/svg/IcoCrown';
import { IcoBanknotes } from '../../components/svg/IcoBanknotes';
import { ProgressBar } from './components/ProgressBar/ProgressBar';
import { RefProgram } from './components/RefProgram/RefProgram';
import { IcoSort } from '../../components/svg/IcoSort';
import { ProfileAccordionContent } from './components/ProfileAccordionContent/ProfileAccordionContent';

interface IProfileSettings {
    name: string;
}

interface ILevel {
    level: number;
    experienceRequired: number;
}
export const Profile: React.FC = () => {
    const [showPopup, togglePopup] = usePopup();

    const [count, setCount] = useState<number>(0);
    const [isOwner, setIsOwner] = useState<boolean>(false);

    const [activeAccordionIndex, setActiveAccordionIndex] = useState<number | null>(null);

    const handleAccordionClick = (index: number) => {
        if (activeAccordionIndex === index) {
            console.log('1 null');
            setActiveAccordionIndex(null);
        } else {
            console.log('index');
            setActiveAccordionIndex(index);
        }
    };

    const handleLike = () => {
        setCount((prevCount: number) => prevCount + 1);
    };

    const profileSettings: IProfileSettings[] = [
        {
            name: 'Настройка профиля',
        },
        {
            name: 'Настройка стримов',
        },
        {
            name: 'Передача поинтов',
        },
        {
            name: 'Генерация промокодов',
        },
    ];

    const levels: ILevel[] = [
        { level: 1, experienceRequired: 0 },
        { level: 2, experienceRequired: 110 },
        { level: 3, experienceRequired: 220 },
        { level: 4, experienceRequired: 330 },
        { level: 5, experienceRequired: 440 },
        { level: 6, experienceRequired: 550 },
        { level: 7, experienceRequired: 660 },
    ];

    return (
        <div className="profile">
            <div className="profile__background-text-container">
                <span className="profile__background-text">Был 1 мин назад</span>
                <span className="profile__background-text">На гетто 36 дней</span>
                <span className="profile__background-text">Ставил 26 д. назад</span>
            </div>
            <button onClick={handleLike} className="profile__like-container">
                <IcoLike />
                <span className="profile__like-text">{count}</span>
            </button>
            <div className="profile__social-container">
                <IcoFacebook />
                <IcoVk />
            </div>
            <div className="profile__summary">
                <div className="profile__avatar-container">
                    <Avatar />
                </div>
                <span className="profile__avatar-name">Peshaman007</span>
                <span className="profile__avatar-name profile__avatar-name-last-child">CSGETTO.CASH</span>
                <span className="profile__avatar-band">(TEAMBAND)</span>
                <span className="profile__avatar-band profile__avatar-rating">19 место в рейтинге</span>
                <div className="profile__avatar-history">
                    <div className="profile__avatar-history-block">
                        <div className="profile__avatar-ico-container">
                            <IcoBattle />
                        </div>

                        <span className="profile__title">1405</span>
                        <span className="profile__text">участий</span>
                    </div>
                    <div className="profile__avatar-history-block">
                        <div className="profile__avatar-ico-container">
                            <IcoCrown />
                        </div>

                        <span className="profile__title">524</span>
                        <span className="profile__text">победы</span>
                    </div>
                    <div className="profile__avatar-history-block">
                        <div className="profile__avatar-ico-container">
                            <IcoBanknotes />
                        </div>

                        <span className="profile__title">123 405</span>
                        <span className="profile__text">р. выиграно</span>
                    </div>
                </div>
            </div>

            <div className="profile__level">
                <ProgressBar levels={levels} />;
            </div>
            <div className="profile__down-container">
                <RefProgram />
                {profileSettings.map((setting, index) => (
                    <div key={index}>
                        <div onClick={() => handleAccordionClick(index)} className="profile__settings">
                            <h2 className="profile__settings-item">
                                {setting.name}
                                <IcoSort />
                            </h2>
                        </div>
                        {activeAccordionIndex === index && (
                            <div className="profile__accordion open">
                                <div className="profile__accordion-content">
                                    <ProfileAccordionContent contentIndex={index} />
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
